import { render } from "./FileDropper.vue?vue&type=template&id=56484f5c"
import script from "./FileDropper.vue?vue&type=script&lang=js"
export * from "./FileDropper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__